"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processDeclarationFunctions = void 0;
const css_selector_tokenizer_1 = require("css-selector-tokenizer");
function processDeclarationFunctions(decl, onFunction, transform = false) {
    const ast = (0, css_selector_tokenizer_1.parseValues)(decl.value);
    ast.nodes.forEach((node) => findFunction(node, onFunction));
    if (transform) {
        decl.value = (0, css_selector_tokenizer_1.stringifyValues)(ast);
    }
}
exports.processDeclarationFunctions = processDeclarationFunctions;
function findFunction(node, onFunctionNode) {
    switch (node.type) {
        case 'value':
        case 'values':
            node.nodes.forEach((child) => findFunction(child, onFunctionNode));
            break;
        case 'url':
            onFunctionNode(node);
            break;
        case 'nested-item':
            onFunctionNode(node);
            node.nodes.forEach((child) => findFunction(child, onFunctionNode));
            break;
    }
}
//# sourceMappingURL=process-declaration-functions.js.map